import axios from 'axios'

let config = axios.create({
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    baseURL: process.env.REACT_APP_API_BASE_URL,
})

const pollStatus = (id) => {
    return config.get(`/api/tasks/${id}/`)
}

const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

config.interceptors.response.use(
    async (response) => {
        if (response.status === 202) {
            console.log('polling...')
            let task_id = response.data.task_id
            let pollResponse = await pollStatus(task_id)
            while (
                pollResponse.data.status !== 'SUCCESS' &&
                pollResponse.data.status !== 'FAILURE'
            ) {
                await timeout(2000)
                pollResponse = await pollStatus(task_id)
            }

            if (pollResponse.data.status === 'FAILURE') {
                throw 'Operation Failed'
            } else {
                // NOTE: this is a bit hacky...
                // Another option is to return resource location of the
                // created object.
                // See: https://endjin.com/blog/2020/10/how-to-use-axios-interceptors-to-poll-long-running-api-calls
                response.status = 200
                response.data = JSON.parse(pollResponse.data.result)
                return response
            }
        }
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

export const useRequestInterceptor = ({ getToken }) => {
    config.interceptors.request.use(async (request) => {
        const token = await getToken()
        request.headers['Authorization'] = `Bearer ${token}`
        return request
    })
}

export default config
